import * as React from "react";
import { AutoComplete, AutoCompleteProps } from "antd";
import {
  formSet,
  formSetValue,
  useCpFormAnyValue,
  useCpFormError,
  useCpFormSimulateTouched,
  useCpFormTouched,
  useCpFormValue,
  useCpFormWarning,
} from "./utils";
import { store } from "../../../store";
import { useCpFormContext } from "../../../components/form/useCpFormContext";

interface Props extends Omit<AutoCompleteProps, "id" | "name" | "value" | "status"> {
  name: string;
}
export const CpAutoComplete = (props: Props): React.ReactElement => {
  const { id } = useCpFormContext();

  const { name, onFocus, onBlur, onChange, ...autoCompleteProps } = props;

  const value = useCpFormValue(name);

  const fieldStatePath = React.useMemo(() => `fieldStates.${name}`, [name]);

  const submitted = useCpFormAnyValue(`meta.submitted`);
  const simulateTouched = useCpFormSimulateTouched(name);
  const touched = useCpFormTouched(name);
  const error = useCpFormError(name);
  const warning = useCpFormWarning(name);

  const canShowErrorWarningStatus = React.useMemo(() => {
    return submitted || simulateTouched || touched;
  }, [submitted, simulateTouched, touched]);

  return (
    <AutoComplete
      {...autoCompleteProps}
      id={name}
      value={value}
      status={canShowErrorWarningStatus ? (error ? "error" : warning ? "warning" : undefined) : undefined}
      onChange={(value) => {
        onChange?.(value);
        formSetValue(id, name, value);
        formSet(id, `${fieldStatePath}.modified`, true);
        const form = store.getState().form.instances[id];
        const onChangeCounter = form.meta.onChangeCounter;
        formSet(id, `meta.onChangeCounter`, onChangeCounter + 1);
      }}
      onFocus={(e) => {
        onFocus?.(e);
        formSet(id, `${fieldStatePath}.focused`, true);
        formSet(id, `${fieldStatePath}.visited`, true);
      }}
      onBlur={(e) => {
        onBlur?.(e);
        formSet(id, `${fieldStatePath}.focused`, false);
        formSet(id, `${fieldStatePath}.touched`, true);
        const form = store.getState().form.instances[id];
        const onBlurCounter = form.meta.onBlurCounter;
        formSet(id, `meta.onBlurCounter`, onBlurCounter + 1);
      }}
    />
  );
};
